import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { constants } from 'src/app/shared/common/contants';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { LoginService } from 'src/app/shared/services/login.service';
import { DetectChangesPopupVaultObjectComponent } from '../detect-changes-popup-vault-object/detect-changes-popup-vault-object.component';
import { FiledownloadComponent } from 'src/app/shared/common/filedownload.component';
export interface FormData {
  type: string;
  tableName: any, 
  buttonName: any,
  headerNameHtml: any;
  dnsId:any;
}

@Component({
    selector: 'app-objectMetadataRefresh-history-popup',
    templateUrl: './objectMetadataRefresh-history-popup.component.html',
    styleUrls: ['./objectMetadataRefresh-history-popup.component.scss'],
    standalone: false
})
export class ObjectMetadataRefreshHistoryPopupComponent implements OnInit {

  headerNameHTML:any;
  gridAPI;

  lastPage;

  currentPage;

  nextPage;

  nextPagePlusOne;
    rowbindingdata;


  totalPages;

  gridColumnAPI;

  columnDefs:any;

  rowClassRules;
  pagesize;
    buttonColor = "";


  defaultColDef;

  rowSelection;

  paginationPageSize;

  paginationNumberFormatter;
  dnsId;

  pageSize;
  backgroundColorScreen="";
  value;
  backgroundColorButton = "";
  gridOptions:any;
  components:any;
  options = [
    { id: "refresh", name: 'Refresh History' },
    { id: "detect_Changes", name: 'Detect Changes History' }
    
  ];
  selectedOption="refresh";
  restApi: any;
  migratorService: any;
  http: any;
  baseUrl: string;
 // components: { buttonRenderer: any; FileUploadButtonRenderer: any; fileDownloadButtonRendered: FiledownloadComponent };
  constructor(
  private dialogref: MatDialogRef<ObjectMetadataRefreshHistoryPopupComponent>,

  @Inject(MAT_DIALOG_DATA) public data: FormData,

  private constants: constants,
  private service: CommonService,
  private sanitizer: DomSanitizer,
  private auth: LoginService,
  private dialog: MatDialog,
  private spinner: NgxUiLoaderService,
  private snackbar: MatSnackBar,                      
  private localStorageSettings: LocalStorageSettingsService,
) {
 
  this.components = {
    buttonRenderer: null,                             
    FileUploadButtonRenderer: null,                   
    fileDownloadButtonRendered: FiledownloadComponent  
  };

  // init dnsId from injected dialog data
  this.dnsId = this.data?.dnsId;
  console.log('dnsId ====>', this.dnsId);

  // defensive: ensure data exists
  if (!this.data) {
    console.warn('ObjectMetadataRefreshHistoryPopupComponent: no MAT_DIALOG_DATA provided');
  }
}


  ngOnInit(): void {
    console.log(this.data);
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
    if (this.data.buttonName == "Import Export History") {
      this.columnDefs = [
        {
          headerName: 'ID',
          headerTooltip: 'ID',
          tooltipValueGetter: (params) => 'ID: ' + params.value,
          field: 'id',
          filter: 'agTextColumnFilter',
          width: 100,
         
        },
        {
          headerName: 'Module ID',
          headerTooltip: 'Module ID',
          tooltipValueGetter: (params) => 'Module ID: ' + params.value,
          field: 'snapshotId',
          filter: 'agTextColumnFilter',
          width: 200,
          
        },

        {
          headerName: 'Start Time',
          headerTooltip: 'Start Time',
          tooltipValueGetter: (params) => 'Start Time: ' + params.value,
          field: 'startedDateTime',
          filter: 'agTextColumnFilter',
          width: 150,
          
        },
        {
          headerName: 'End Time',
          headerTooltip: 'End Time',
          tooltipValueGetter: (params) => 'End Time : ' + params.value,
          field: 'completedDateTime',
          filter: 'agTextColumnFilter',
          width: 150,
        
        },
        {
          headerName: 'Status',
          headerTooltip: 'Status',
          tooltipValueGetter: (params) => 'Status: ' + params.value,
          field: 'status',
          filter: 'agTextColumnFilter',
          width: 150,
          
        },
        {
          headerName: 'Remarks',
          headerTooltip: 'Remarks',
          tooltipValueGetter: (params) => 'Remarks: ' + params.value,
          field: 'remarks',
          filter: 'agTextColumnFilter',
          width: 250,
         
        },
        {
          headerName: 'Table Name',
          headerTooltip: 'Table Name',
          tooltipValueGetter: (params) => 'Table Name: ' + params.value,
          field: 'tableName',
          filter: 'agTextColumnFilter',
          width: 150,
          
        }, 

        {
          headerName: 'Tenant Type',
          headerTooltip: 'Tenant Type',
          tooltipValueGetter: (params) => 'Tenant Type: ' + params.value,
          field: 'tenantType',
          filter: 'agTextColumnFilter',
          width: 150,
          
        },
        {
          headerName: 'DNS Name',
          headerTooltip: 'DNS Name',
          tooltipValueGetter: (params) => 'DNS Name: ' + params.value,
          field: 'dnsName',
          filter: 'agTextColumnFilter',
          width: 250,
          
        },
        {
          headerName: 'Imported By',
          headerTooltip: 'Imported By',
          tooltipValueGetter: (params) => 'Imported By: ' + params.value,
          field: 'importedBy',
          filter: 'agTextColumnFilter',
          width: 250,
          
        },
        {
          headerName: 'Exported By',
          headerTooltip: 'Exported By',
          tooltipValueGetter: (params) => 'Exported By: ' + params.value,
          field: 'exportedBy',
          filter: 'agTextColumnFilter',
          width: 250,
          
        },
         {
        headerName: "Download Log",
        headerTooltip: "Download Log",
        tooltipValueGetter: (params) => "Download Log",
        ///  field: "status",
        filter: "agTextColumnFilter",
        width: 150,
        cellRenderer: "fileDownloadButtonRendered",
        cellRendererParams: {
          docdownload: this.downloadMappingFile.bind(this)

        },
      }
      ]
      
    } else {
      this.columnDefs = [

        {
          headerName: 'Refresh Start Time',
          headerTooltip: 'Refresh Start Time Name',
          tooltipValueGetter: (params) => 'Refresh Start Time: ' + params.value,
          field: 'refreshStartTimeDate',
          filter: 'agTextColumnFilter',
          width: 250,
          flex: 1,
        },
        {
          headerName: 'Refresh End Time',
          headerTooltip: 'Refresh End Time',
          tooltipValueGetter: (params) => 'Refresh End Time : ' + params.value,
          field: 'refreshEndTimeDate',
          filter: 'agTextColumnFilter',
          width: 250,
          flex: 1,
        },
        {
          headerName: 'Status',
          headerTooltip: 'Status',
          tooltipValueGetter: (params) => 'Status: ' + params.value,
          field: 'status',
          filter: 'agTextColumnFilter',
          width: 250,
          flex: 1,
        },
        {
          headerName: 'Remarks',
          headerTooltip: 'Remarks',
          tooltipValueGetter: (params) => 'Remarks: ' + params.value,
          field: 'remarks',
          filter: 'agTextColumnFilter',
          width: 250,
          flex: 1,
        },
        {
          headerName: 'Machine Id',
          headerTooltip: 'Machine Id',
          tooltipValueGetter: (params) => 'Machine Id: ' + params.value,
          field: 'machineId',
          filter: 'agTextColumnFilter',
          width: 250,
          flex: 1,
        },
      ]
    }
    

     // below object is resizable, sorting and filter for ag-grid
     this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");

    this.gridOptions = {
      onFirstDataRendered: (params) => {
        params.api.setGridOption('paginationPageSize', 10); // Set the desired row limit here
      }
    };

  }
  onBtExport() {
    if (!this.gridAPI) {
      console.error("Grid API not ready");
      return;
    }
    this.gridAPI.exportDataAsCsv();
  }

   //pagination code
   onPaginationChanged() {
    if (this.gridAPI) {
      this.lastPage = this.gridAPI.paginationIsLastPageFound();
      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1
      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1
      this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalPages = this.gridAPI.paginationGetTotalPages()
      var value = this.pagesize
      this.rowbindingdata.api.setGridOption('paginationPageSize', Number(value));
    }
  }
 

   // below function is to load the ag grid
   onGridReady(params) {
    this.gridAPI = params.api;
    this.gridColumnAPI = params.columnApi;
    // let dnsId = this.localStorageSettings.getSettings("dnsName")
    this.spinner.start();
    
     if (this.data.buttonName == "Import Export History") {
       this.service.retrieveImportExportHistory(this.dnsId).subscribe(response => {

         if (response.error == true) {

           this.spinner.stop();

           this.snackbar.open(response.statusMessage, "OK", { duration: 5000 });

         }
         else {
           console.log(response)
           response = response.map(item => {
             if (!item.importedBy) {
               item.status = `Export ${item.status}`;
             } else if (!item.exportedBy) {
               item.status = `Import ${item.status}`;
             }
             return item;
           });
           console.log(response)


           this.gridAPI.setGridOption('rowData', response);
           this.spinner.stop();
         }
       })
     } else {

      if(this.data.type === 'jeevobjects'){
      this.service.getJeevObjectsRefreshHistory().subscribe(response=>{
          this.gridAPI.setGridOption('rowData', response);
          this.spinner.stop();
      })
  }
  else{
       this.service.retrieveRefreshHistory(this.dnsId).subscribe(response => {

         if (response.error == true) {

           this.spinner.stop();

           this.snackbar.open(response.statusMessage, "OK", { duration: 5000 });

         }
         else {
           this.gridAPI.setGridOption('rowData', response);
           this.spinner.stop();
         }
       })
     }
    }
     

  }
  //this function is for going to the given page number
  onSearchChange(searchValue: number) {
    this.gridAPI.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {
    var value = this.pageSize;
    this.gridAPI.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridAPI.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridAPI.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    this.gridAPI.paginationGoToFirstPage();
  }
downlod() {
    this.rowbindingdata.api.exportDataAsCsv();
  }
  // below function for going to last page
  onBtLast() {
    this.gridAPI.paginationGoToLastPage();
  }
  //pagination code ends

  cancel() {

    this.dialogref.close();

  }


  onSelectionChange(){
    console.log(this.selectedOption)
    // let dnsId = this.localStorageSettings.getSettings("dnsName")
    this.spinner.start();
    if(this.selectedOption === "detect_Changes"){
      this.service.retrieveObjectDetectChangesHistory(this.dnsId).subscribe(response=>{
        this.columnDefs = [
    
          {
            headerName: 'Detect Changes Start Time',
            headerTooltip: 'Detect Changes Start Time ',
            tooltipValueGetter: (params) => 'Detect Changes Start Time: ' + params.value,
            field: 'refreshStartTimeDate',
            filter: 'agTextColumnFilter',
            width: 250,
            flex: 1,
          },
          {
            headerName: 'Detect Changes End Time',
            headerTooltip: 'Detect Changes End Time',
            tooltipValueGetter: (params) => 'Detect Changes End Time : ' + params.value,
            field: 'refreshEndTimeDate',
            filter: 'agTextColumnFilter',
            width: 250,
            flex: 1,
          },
          {
            headerName: 'Status',
            headerTooltip: 'Status',
            tooltipValueGetter: (params) => 'Status: ' + params.value,
            field: 'status',
            filter: 'agTextColumnFilter',
            width: 250,
            flex: 1,
          },
        ]
      
        if (response.error == true) {
    
          this.spinner.stop();
    
          this.snackbar.open(response.statusMessage, "OK", { duration: 5000 });
    
        }
        else {

          this.gridAPI.setGridOption('rowData', response);
          this.spinner.stop();
        }
        })
    }else{
      this.service.retrieveRefreshHistory(this.dnsId).subscribe(response=>{
         this.columnDefs = [
    
      {
        headerName: 'Refresh Start Time',
        headerTooltip: 'Refresh Start Time Name',
        tooltipValueGetter: (params) => 'Refresh Start Time: ' + params.value,
        field: 'refreshStartTimeDate',
        filter: 'agTextColumnFilter',
        width: 250,
        flex: 1,
      },
      {
        headerName: 'Refresh End Time',
        headerTooltip: 'Refresh End Time',
        tooltipValueGetter: (params) => 'Refresh End Time : ' + params.value,
        field: 'refreshEndTimeDate',
        filter: 'agTextColumnFilter',
        width: 250,
        flex: 1,
      },
      {
        headerName: 'Status',
        headerTooltip: 'Status',
        tooltipValueGetter: (params) => 'Status: ' + params.value,
        field: 'status',
        filter: 'agTextColumnFilter',
        width: 250,
        flex: 1,
      },
    ]
      
        if (response.error == true) {
    
          this.spinner.stop();
    
          this.snackbar.open(response.statusMessage, "OK", { duration: 5000 });
    
        }
        else {
          this.gridAPI.setGridOption('rowData', response);
          this.spinner.stop();
        }
        })

    }
   
     
  }

  onRowClicked(event) {
    if (this.data.buttonName == "Import Export History") {
      
    } else {
      console.log(event)
      if (event.data.status === "In Progress") {
        this.snackbar.open("Please wait Objects Refresh is In Progress.", "OK", { duration: 5000 });
        return;
      }
      let width = "90%";
      let dialogRef = this.dialog.open(DetectChangesPopupVaultObjectComponent, {
        maxWidth: '100vw',
        height: "80%",
        width: width,
        data: { data: event.data.id, dnsId: this.dnsId }

      });

    }
          
     }

     /**
 * Modified by Sujeet 
 *  01/12/2025
 * Added S3 log file download handling for snapshot history.
 */

downloadMappingFile(e) {
  console.log(e);
  console.log(e.rowData);

  // allow download only for imported rows
  if (!e.rowData.importedBy) {
    this.snackbar.open("Download allowed only for Imported records", "OK", {
      panelClass: 'snack'
    });
    return;
  }

  // check for s3 path
  if (!e.rowData.s3logpath) {
    this.snackbar.open("Folder does not exist", "OK", { panelClass: 'snack' });
    return;
  }

  this.spinner.start();

  // ⭐ REQUIRED CHANGE: send DTO object { s3Path: value }
  this.service.downloadCsvFileFromS3({ s3Path: e.rowData.s3logpath }).subscribe(
    (response: any) => {
      let blob: Blob;

      if (response instanceof Blob) {
        blob = response;
      } else if (typeof response === 'string') {
        blob = new Blob([response], { type: 'text/csv' });
      } else if (response instanceof ArrayBuffer) {
        blob = new Blob([response], { type: 'text/csv' });
      } else {
        blob = new Blob([JSON.stringify(response)], { type: 'application/json' });
      }

      let filename = 'download.csv';
      if (e.rowData.fileName) {
        filename = e.rowData.fileName.endsWith('.csv')
          ? e.rowData.fileName
          : `${e.rowData.fileName}.csv`;
      } else {
        const last = e.rowData.s3logpath.split('/').pop();
        filename = last?.endsWith('.csv') ? last : `${last}.csv`;
      }

      if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
        (window.navigator as any).msSaveOrOpenBlob(blob, filename);
        this.spinner.stop();
        return;
      }

      const data = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = data;
      link.download = filename;
      link.dispatchEvent(new MouseEvent('click'));

      setTimeout(() => {
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);

      this.spinner.stop();
    },
    (err) => {
      this.snackbar.open('Error downloading file', 'OK', { duration: 5000 });
      this.spinner.stop();
    }
  );
}

}
